var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    color: "#07272D",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_2579_1536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8283 7.79475C20.7613 7.86171 18.2502 9.31817 18.2502 12.3566C18.3171 16.0061 21.4226 17.1947 21.4895 17.1947C21.4895 17.3287 21.0292 18.986 19.8405 20.635C18.8528 22.0831 17.8568 23.5395 16.2078 23.5395C14.609 23.5981 14.0901 22.6104 12.2402 22.6104C10.3903 22.6104 9.79603 23.5312 8.27261 23.5981C6.6906 23.6651 5.49363 22.0161 4.50592 20.5597C2.45516 17.5882 0.864782 12.1641 3.04946 8.46438C4.03718 6.68148 5.954 5.49288 7.9378 5.49288C9.53655 5.49288 10.9177 6.54756 11.9054 6.54756C12.8345 6.54756 14.6174 5.22503 16.4673 5.42592C17.1955 5.42592 19.4388 5.74399 20.8283 7.79475Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5342 -0.399902C16.6682 0.989589 16.0739 2.37908 15.2787 3.43375C14.4165 4.42984 13.027 5.21666 11.7715 5.14969C11.5706 3.7602 12.2988 2.31212 13.027 1.44996C13.8892 0.395289 15.3456 -0.332939 16.5342 -0.399902Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_1536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.08410ba7d2aa99ba1c4fa87ad456e54e.svg";
export { ForwardRef as ReactComponent };